import {Component, EventEmitter, HostBinding, HostListener, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {GlobalValidator} from '../../../../shared/validators/global-validator';

@Component({
  selector: 'app-mail-address',
  templateUrl: './mail-address.component.html',
  styleUrls: ['./mail-address.component.scss']
})
export class MailAddressComponent implements OnInit {
  primaryEmail: FormControl;
  @Output() addEmailAddress: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeEmailAddress: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.primaryEmail = new FormControl(null,
      [GlobalValidator.mailFormat, Validators.required]);
  }

  onKeyPressHandler(event) {
    const key =  event.which || event.keyCode || 0;
    if (key === 13) {
      this.addEmail(this.primaryEmail);
      return false;
    } else if (key === 32) {
      this.addEmail(this.primaryEmail);
    }
  }

  addEmail(email: FormControl): void {
    if (!email.value) {
      return;
    }
    email.setValue(email.value.trim());
    if (email.valid) {
      this.addEmailAddress.emit(email.value);
      email.setValue(null);
    }
  }

  @HostListener('focusout', ['$event'])
  onFocusOut($event) {
    this.addEmail(this.primaryEmail);
  }

  @HostListener('keydown', ['$event'])
  onKeyDownEvent($event: KeyboardEvent) {
    const key =  $event.which || $event.keyCode || 0;
    if (key === 8) {
      if (this.primaryEmail.value) {
        return true;
      }
      this.removeMail();
      return false;
    }
  }

  private removeMail() {
    this.removeEmailAddress.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/output/mail/mail-address/mail-address.component.ts